export const MEDIA_TRASH_SCOPE = 'media-trash';
